import React from 'react';
import { useMessageContext } from 'stream-chat-react';

const CustomMessageTimestamp = () => {
  const { message } = useMessageContext();

  if (!message?.created_at) return null;

  const date = new Date(message.created_at);

  let formattedTime = date.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  // Convert AM/PM to lowercase with periods
  formattedTime = formattedTime
    .replace('AM', 'a.m.')
    .replace('PM', 'p.m.')
    .replace('am', 'a.m.')
    .replace('pm', 'p.m.');

  return (
    <span
      className="custom-message-timestamp"
      style={{ fontSize: '12px', color: '#888', marginLeft: '4px' }}
    >
      {formattedTime}
    </span>
  );
};

export default CustomMessageTimestamp;
